import { toText } from "./toText";
export function buildMappingKey(integrationId: string, costTypeUuid: string): string {
  return `${integrationId}||${costTypeUuid}`;
}

export function resolve1CPrice(costArrUuid: Record<string, string> | undefined, mappingKeys: string[]): number | null {
  if (!costArrUuid || mappingKeys.length === 0) return null;

  for (const key of mappingKeys) {
    const rawPrice = costArrUuid[key];
    if (rawPrice === undefined) continue;

    const parsed = Number(String(rawPrice).replace(",", ".").replace(/\s/g, ""));
    if (Number.isNaN(parsed) || parsed === 0) continue;

    return parsed;
  }

  return null;
}

export interface ResolvedCost {
  /** Цена закупки позиции: из 1С по сопоставлению «Цена закупки» либо прежняя цена поставщика. */
  value: number;
  is1c: boolean;
}

export function parsePriceValue(raw: unknown): number {
  if (raw === null || raw === undefined) return 0;
  const parsed = Number(toText(raw).replace(",", ".").replace(/\s/g, ""));
  return Number.isNaN(parsed) ? 0 : parsed;
}

/**
 * Цена для столбца «Цена» (CAB-574 п.1): у складских позиций 1С «главной» цены нет,
 * закупочной считается цена по сопоставлению «Цена закупки → тип цен 1С». Если ключа
 * или цены нет — остаётся прежняя цена (поставщика / по формуле).
 */
export function resolvePurchaseCost(
  row: { cost?: unknown; cost_arr_uuid?: Record<string, string> } | null | undefined,
  mappingKeys: string[],
): ResolvedCost {
  const baseCost = parsePriceValue(row?.cost);
  if (!row || mappingKeys.length === 0) return { value: baseCost, is1c: false };

  const price1c = resolve1CPrice(row.cost_arr_uuid, mappingKeys);
  if (price1c === null) return { value: baseCost, is1c: false };

  return { value: price1c, is1c: true };
}

/**
 * База 1С позиции — из префикса ключей cost_arr_uuid («<integration_id>||<uuid>»).
 * Отдельного поля базы в строке выдачи нет, а справочники шлюза (контрагенты) умеют
 * ограничивать поиск одной базой.
 */
export function extractIntegrationId(costArrUuid?: Record<string, string>): string | undefined {
  const key = Object.keys(costArrUuid ?? {}).find((candidate) => candidate.includes("||"));
  return key ? key.slice(0, key.indexOf("||")) : undefined;
}
